'use client'

import { useState } from 'react'
import { useRouter, usePathname } from 'next/navigation'
import { toast } from '@/lib/toast'
import { navigateUrl } from '@/utils/client-request'
import { isValidPhoneNumber } from '@/utils/util'

type Errors = { orderNum?: string; phoneNum?: string }

export function useOrderLookup({ initialOrderNum, initialPhoneNum }: { initialOrderNum?: string; initialPhoneNum?: string } = {}) {
  const router = useRouter()
  const pathname = usePathname()
  const [orderNum, setOrderNum] = useState(initialOrderNum || '')
  const [phoneNum, setPhoneNum] = useState(initialPhoneNum || '')
  const [errors, setErrors] = useState<Errors>({})
  const [isLoading, setIsLoading] = useState(false)

  const submit = () => {
    const errs: Errors = {}
    if (!orderNum) errs.orderNum = 'Захиалгын дугаар оруулна уу'
    if (!phoneNum) errs.phoneNum = 'Утасны дугаар оруулна уу'
    else if (!isValidPhoneNumber(phoneNum)) errs.phoneNum = 'Утасны дугаар буруу байна'
    setErrors(errs)
    if (Object.keys(errs).length) {
      const first = errs.orderNum || errs.phoneNum
      if (first) toast.error(first)
      return
    }
    setIsLoading(true)
    try {
      const cleanOrderNum = orderNum.replace(/^#/, '')
      router.push(navigateUrl(`/order/${cleanOrderNum}/${phoneNum}`, pathname))
    } catch {
      toast.error('Захиалгыг шалгахад алдаа гарлаа. Дахин оролдоно уу.')
      setIsLoading(false)
    }
  }

  return {
    orderNum, setOrderNum,
    phoneNum, setPhoneNum,
    errors, isLoading,
    submit,
  }
}
